import React, { useRef, useState, useEffect } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import { useNavigate } from "react-router-dom";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";

import AnalyticsIcon1 from "../../Assets/Logos/notice/AnalyticsIcon1.png";
import AnalyticsIcon2 from "../../Assets/Logos/notice/AnalyticsIcon2.png";
import AnalyticsIcon3 from "../../Assets/Logos/notice/AnalyticsIcon3.png";
import AnalyticsIcon4 from "../../Assets/Logos/notice/AnalyticsIcon4.png";

import addNoticeIcon from "../../Assets/Logos/notice/addNoticeIcon.png";
import deleteIcon from "../../Assets/Logos/notice/deleteIcon.png";
import editIcon from "../../Assets/Logos/notice/editIcon.png";
import axios from "axios";
import CheckOutModal from "../../components/AdminSideComponents/CheckOutModal";
import { useApi } from "../../utils/useApi";
import ViewNoticeModal from "../../components/AdminSideComponents/ViewNoticeModal";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import DeleteConfirmationModal from "../../components/AdminSideComponents/DeleteConfirmationModal";

// dummy data for analytics cards  at top...
// const items = [
//   { name: "Total Number Of Notices", numberOfItems: 350, icon: AnalyticsIcon1 },
//   {
//     name: "Total Number of Vacant Beds",
//     numberOfItems: 10,
//     icon: AnalyticsIcon2,
//   },
//   { name: "Total Number of Beds", numberOfItems: 80, icon: AnalyticsIcon3 },
//   {
//     name: "Total Number of Beds Occupied",
//     numberOfItems: 120,
//     icon: AnalyticsIcon4,
//   },
// ];

const Notice = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [checkIns, setCheckins] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentCheckIn, setCurrentCheckIn] = useState({});
  const [isViewNoticeModalOpen, setIsViewNoticeModalOpen] = useState(false); //
  const [isCheckOutModalOpen, setIsCheckOutModalOpen] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);
  const navigate = useNavigate();
  const dropdownRefs = useRef([]);
  const itemsPerPage = 10;

  const [dropdownPosition, setDropdownPosition] = useState("down");

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 200 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  const getAllNotice = (page) => {
    setLoading(true);
    const tenantStatus = "Check In";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_data_notice?page=${page}&limit=${itemsPerPage}&search=${searchQuery}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------>", response.data);
        setCheckins(response.data.data);
        setLoading(false);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getAllNotice(currentPage);
    }, 800); // Waits for 500ms of inactivity
    return () => clearTimeout(timeout);
  }, [currentPage, searchQuery]);

  useEffect(() => {
    getAllNotice(currentPage);
  }, [isDataChanged]);

  // const toggleDropdown = (index) => {
  //   setShowDropdown(showDropdown === index ? null : index);
  // };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="noticeConatinaer p-6 bg-primarybgColor ">
      <CheckOutModal
        isOpen={isModalOpen}
        currentCheckIn={currentCheckIn}
        onClose={() => setModalOpen(false)}
      />
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Notice
      </h1>
      {/* <Cards items={items} /> */}

      <div className="p-4 bg-white shadow-lg mt-6 rounded-lg overflow-hidden ">
        <div className="flex w-full  overflow-hidden justify-evenly flex-wrap  md:justify-between items-center gap-4  mb-4">
          <h1 className="text-[18px] min-w-fit  text-primaryTextColor sm:text-[24px] font-bold">
            Notice List
          </h1>

          <div className="relative flex items-center   gap-3">
            <div className="relative   ">
              <input
                type="text"
                placeholder="Search..."
                className="border border-gray-300 w-[100%] lg:w-auto  rounded-lg p-2 pl-8 pr-8 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

              {searchQuery && (
                <FaTimes
                  onClick={clearSearch}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-secondaryTextColor cursor-pointer"
                />
              )}
            </div>

            {/* <img
              src={addNoticeIcon}
              className="h-9 w-9 object-cover"
              alt="Add"
            /> */}
          </div>
        </div>

        <div className="overflow-x-auto  min-h-[70vh]">
          <table className="min-w-full bg-white  border-gray-200 rounded-md  ">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Room No
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Bed No
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Building Name
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Date of Notice
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Reason Of Notice
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Leaving Date
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {loading ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b  border-gray-200 animate-pulse"
                  >
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-4/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4   px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                    <td className="py-4  px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-2/4"></div>
                    </td>
                  </tr>
                ))
              ) : checkIns?.length > 0 ? (
                checkIns.map((data, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-nowrap text-center text-primaryTextColor">
                      {data?.name}
                    </td>

                    <td className="py-4 px-6 text-sm text-nowrap text-center text-primaryTextColor">
                      R-F{data?.floorNo}
                      {String(data?.roomId?.roomNumber).padStart(3, "0")}
                    </td>
                    <td className="py-4 px-6 text-sm text-nowrap text-center text-primaryTextColor">
                      {data?.bedId?.bedNumber}
                    </td>
                    <td className="py-4 px-6 text-sm text-nowrap text-center text-primaryTextColor">
                      {data?.hostelName?.nameBuilding}
                    </td>

                    <td className="py-4 px-6 text-sm text-nowrap text-center text-primaryTextColor">
                      {data?.notice?.noticeRaisedOn?.slice(0, 10)}
                    </td>
                    <td className="py-4 px-6  text-sm  text-center text-primaryTextColor">
                      <span className="text-nowrap justify-center flex gap-2 items-center">
                        {" "}
                        {data?.notice?.reasonOfNotice?.slice(0, 10) + "..."}
                        <MdOutlineRemoveRedEye
                          className="w-4 h-4 cursor-pointer "
                          onClick={() => {
                            setCurrentCheckIn(data);
                            setIsViewNoticeModalOpen(true);
                          }}
                        />
                      </span>
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-nowrap text-primaryTextColor">
                      {data?.notice?.leavingDate?.slice(0, 10)}
                    </td>

                    <td className="py-4 px-6  text-sm text-center hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                      <div
                        className="relative"
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div
                            className={`absolute ${
                              dropdownPosition === "up"
                                ? "bottom-full mb-2"
                                : "top-full mt-2"
                            } right-0 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-30`}
                          >
                            <ul className="py-1">
                              <li
                                onClick={() => {
                                  setCurrentCheckIn(data);
                                  setIsCheckOutModalOpen(true);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="edit"
                                />{" "}
                                Check Out
                              </li>
                              <li
                                onClick={() => {
                                  setCurrentCheckIn(data);
                                  setIsDeleteConfirmationModalOpen(true);
                                  setShowDropdown(false);
                                }}
                                className="text-gray-900 flex gap-2  items-center  hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="delete"
                                />{" "}
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className=" px-6 h-[70vh]  text-lg text-center text-secondaryTextColor"
                  >
                    No Notices available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalCheckIns)} of{" "}
            {pagination.totalCheckIns}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
      <ViewNoticeModal
        isOpen={isViewNoticeModalOpen}
        onClose={() => setIsViewNoticeModalOpen(false)}
        data={currentCheckIn}
      />

      <CheckOutModal
        isOpen={isCheckOutModalOpen}
        onClose={() => setIsCheckOutModalOpen(false)}
        currentCheckIn={currentCheckIn}
        dataChanged={() => setIsDataChanged((prev) => !prev)}
      />

      <DeleteConfirmationModal
        isOpen={isDeleteConfirmationModalOpen}
        onClose={() => setIsDeleteConfirmationModalOpen(false)}
        currentCheckIn={currentCheckIn}
        getAllNotice={getAllNotice}
      />
    </div>
  );
};

export default Notice;
